module.exports = __webpack_public_path__ + "static/media/sms-otp-consent-logo.80665784.png";